export default {"src":"/_next/static/media/youtube.1bb3b2cc.svg","height":9,"width":12};